
import union from '~/assets/images/main/icons/union-white.svg'
export default {
  name: 'Checkbox',
  props: ['label', 'fontSize'],
  data() {
    return {
      isChecked: false,
      union,
    };
  },
methods: {

},
  mounted() {
    this.isChecked = false
  }

};
